import { formatter } from "./formatter";

export const promotion = {
	defaultName: "Copia de {{promotion}}",
	errors: {
		nameLength: "El nombre de la promoción no alcanzó la cantidad mínima de caracteres.",
		sameName: "El nombre de la copia es igual al nombre original.",
		notFilledCorrectly: "Los campos no fueron llenados correctamente.",
	},
	copyModal: {
		okText: "Copiar",
		title: "Crear copia de promoción",
		message: "¿Desea crear copia de la promoción",
		placeholder: "Nombre de la copia de promoción",
	},
	peopleTable: {
		example: "hoja de cálculo ejemplo",
		error: "Formato inválido",
		import: "Importar hoja de cálculo",
		download: "Descargar hoja de cálculo ejemplo",
	},
	categoryModal: {
		title: "Agregar nuevo producto",
		label: "Producto o categoría",
		placeholder: "Busque por un producto o categoría",
		noneProduct: "Ningún producto encontrado",
	},
	creationStep: {
		formatter,
		error: "No fue posible redireccionar página.",
		steps: {
			promotionInfo: "Datos de la promoción",
			goals: "Metas",
			awards: "Premios",
			usageConditions: "Condiciones de uso",
			resume: "Resumen",
		},
		stepsPages: {
			goals: {
				tableWarningMessage: "Información no disponible para Mesas.",
				label: "Recurrencia de ganancias",
				placeholder: "Seleccione una recurrencia máxima de ganancias",
				error: "Condición TODOS LOS CLIENTES necesita ser eliminada",
				new: "Nueva meta",
				add: "Agregar meta",
				goalTypeTitle: "Seleccione el tipo de meta",
				conditions: {
					birthday: {
						month: "Cumpleañero del mes",
						week: "Cumpleañero de la semana",
						day: "Cumpleañero del día",
					},
					checkin: {
						label: "Horario de llegada",
					},
					gender: {
						male: "Hombres",
						female: "Mujeres",
						others: "Otros",
					},
					minimumRecharge: {
						label: "Valor mínimo de la recarga",
					},
				},
			},
			usageConditions: {
				conditions: {
					expiration: {
						label: "Días corridos:",
						suffix: "Días",
					},
					period: {
						beginTime: "De:",
						endTime: "Hasta:",
						error: "Hora en formato inválido para la conversión",
					},
					week: {
						infoText:
							"Como los eventos pueden comenzar en un día de la semana y terminar en otro, la promoción es válida en el día que el evento comienza. Entonces, el cliente puede usar la promoción al día siguiente, si el evento comenzó el día anterior.",
						validPromotion: "Promoción válida ",
					},
					modal: {
						new: "Nueva condición de uso",
						add: "Agregar condición de uso",
					},
				},
				totem: {
					importantTitle: "Importante",
					importantBuyAndEarn:
						"Las condiciones de uso para 'Compre y Gane' también se usan para ganar la promoción.",
					importantExpiration:
						"La expiración posganancia no se aplica para 'Compre y Gane'.",
					weekDaysTitle: "Días de la semana",
					weekDaysDescription:
						"Defina qué días de la semana el cliente puede utilizar la promoción.",
					periodTitle: "Días y horario de uso",
					periodDescription:
						"Defina la franja horaria y/o los días de la semana en que los clientes podrán utilizar la promoción",
				},
			},
		},
		stepsWrapper: {
			title: "Título no encontrado",
			description: "Descripción no encontrada",
			save: "Guardar cambios",
		},
	},
	table: {
		goals: {
			label: "Lista de metas de la promoción",
			empty: "Ninguna meta",
			new: "Nueva meta",
		},
		usageConditions: {
			label: "Lista de condiciones de uso de la promoción",
			empty: "Ninguna condición de uso",
			new: "Nueva condición de uso",
		},
	},
};
